// extracted by mini-css-extract-plugin
module.exports = {"scrim":"OverlayShell_scrim__PkTm7","box":"OverlayShell_box__zXWAl"};